import {styled} from '@mui/system';

export const PaymentMethodSelectorBody = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PaymentMethodSelectorButtons = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  justify-content: center;
`;

export const PaymentMethodSelectorHeader = styled('h2')`
  margin: 0;
  font-size: 1em;
  font-weight: 600;
`;

export const PaymentMethodButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const CheckoutWithCardButton = styled(PaymentMethodButton)`
  background: #fff;
  color: #000;
  border: 1px solid #000;
`;

export const ApplePayButton = styled(PaymentMethodButton)`
  background: #000;
  color: #fff;
`;

export const GooglePayButton = styled(PaymentMethodButton)`
  background: #000;
  color: #fff;
`;
